module.exports = __webpack_public_path__ + "static/media/eye.584c2c89.svg";